import { Component } from '@angular/core';
import { TableColumnToggleBaseEditor } from '../base/toggle-base-editor';

@Component({
  selector: 'table-column-slide-toggle-editor',
  template: ''
})
export class TableColumnSlideToggleEditorComponent extends TableColumnToggleBaseEditor {
}
